import { GameObject } from "../core/GameObject";
import ResizableScene from "../core/ResizableScene";

export class LightningParticleEmitter extends GameObject {
	particles: Phaser.GameObjects.Image[] = [];
	lifespan = 3;
	constructor(scene: ResizableScene) {
		super(scene);

		const count = 16;
		const maxDist = 30;

		for (let i = 0; i < count; i++) {

			let dist = (i / count) * maxDist;
			let ang = Phaser.Math.RND.realInRange(0, 2 * Math.PI) + (i / count) * 4 * Math.PI;
			const dx = Math.cos(ang);
			const dy = Math.sin(ang);

			const img = new Particle(scene, "slamParticleLightning");
			this.add(img);
			this.particles.push(img);
			img.setPosition(dist * dx, dist * dy);
			img.vx = Phaser.Math.RND.realInRange(0, 400) * dx;
			img.vy = Phaser.Math.RND.realInRange(0, 400) * dy;
		}
	}

	update(dt: number): void {
		super.update(dt);
		for (const particle of this.particles) particle.update(dt);
		this.lifespan -= dt;
		if (this.lifespan < 0) this.destroy();
	}
}

class Particle extends Phaser.GameObjects.Image {
	vx: number;
	vy: number;
	va: number;
	lifespan = 1;

	constructor(scene: ResizableScene, texture: string) {
		super(scene, 0, 0, texture);
		this.angle = Phaser.Math.RND.realInRange(0, 360);
		this.va = Math.pow(Phaser.Math.RND.realInRange(0, 1), 2) * 360 * 4;
	}

	update(dt: number): void {
		this.x += this.vx * dt;
		this.y += this.vy * dt;
		this.angle += this.va * dt;
		this.lifespan -= dt;
		this.alpha = Phaser.Math.Clamp(this.lifespan, 0, 1);
	}
}